import { render, staticRenderFns } from "./DocumentAttachment.vue?vue&type=template&id=a5533d64&scoped=true&"
import script from "./DocumentAttachment.vue?vue&type=script&lang=js&"
export * from "./DocumentAttachment.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAttachment.vue?vue&type=style&index=0&id=a5533d64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5533d64",
  null
  
)

export default component.exports